<template>
    <view-container>
        <start-dca-description />

        <template #footer>
            <call-to-action :disabled="!authenticationStore.user.initialized" @clicked="emit(EmitEvents.COMPLETED)">
                {{ t('widget.dollar-cost-average.start-dca.submit') }}
            </call-to-action>
        </template>
    </view-container>
</template>

<script lang="ts" setup>
import StartDcaDescription from '@/dollar-cost-average/components/start-dca-description.vue';
import { CallToAction, ViewContainer } from '@btcdirect/components';
import { useTranslations } from '@btcdirect/composables';
import { EmitEvents } from '@btcdirect/shared/src/components/types';
import { useAuthenticationStore } from '@btcdirect/stores';

const emit = defineEmits([EmitEvents.COMPLETED]);

const authenticationStore = useAuthenticationStore();
const { t } = useTranslations();
</script>
